import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { toast } from 'react-hot-toast'

import { resetPassword } from '../../store/slices/user.slice'
import { images } from '../../services/images.service'

export function ForgotPassword() {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [email, setEmail] = useState('')

  async function onSubmit(ev) {
    ev.preventDefault()
    try {
      await dispatch(resetPassword(email)).unwrap()
      toast.success('אימייל לאיפוס סיסמה נשלח בהצלחה!')
      navigate('/login')
    } catch (err) {
      toast.error(err || 'שגיאה באיפוס הסיסמה')
    }
  }

  return (
    <section className="flex flex-col items-center min-h-screen">
      <div className="w-full flex flex-col bg-secondaryBackground items-center max-w-[450px] max-h-[450px] border-primary border-2 rounded-lg shadow-lg p-6">
        {/* כפתור סגירה */}
        <button className="self-end mb-4" onClick={() => navigate(-1)}>
          <img src={images.closeMenu} alt="Close Menu" className="w-10 h-10" />
        </button>

        {/* כותרות */}
        <div className="text-center mb-6">
          <h1 className="text-2xl text-softText mb-2">איפוס סיסמה</h1>
          <h2 className="text-sm text-muted">
            הכנס את כתובת האימייל שלך ואנו נשלח לך קישור לאיפוס הסיסמה
          </h2>
        </div>

        {/* טופס */}
        <form className="flex flex-col gap-6 w-full" onSubmit={onSubmit}>
          {/* אימייל */}
          <div className="flex flex-col">
            <label htmlFor="email" className="text-softText font-medium mb-2">
              אימייל
            </label>
            <input
              id="email"
              name="email"
              type="email"
              placeholder="אימייל"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full px-4 py-2 border border-primary bg-secondary text-softText placeholder-secondaryText focus:outline-none focus:ring-2 focus:ring-accent"
            />
          </div>

          {/* כפתור שליחה */}
          <button
            type="submit"
            className="w-full py-2 bg-primary text-white rounded-md"
          >
            שלח
          </button>
        </form>
      </div>
    </section>
  )
}
